import api from "../utils/api";

export const createTeacher = async (formData) => {
  try {
    const response = await api.post("/teacher/createTeacher", formData);
    console.log("response", response);
  } catch (error) {
    console.log("error", error);
  }
};

export const getAllTeachers = async () => {
  try {
    const response = await api.get("teacher/getAllTeachers");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginTeacher = async (loginData) => {
  try {
    const response = await api.post(`/teacher/loginTeacher`, loginData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateTeacher = async (TeacherId, formData) => {
  try {
    const response = await api.put(
      `teacher/updateteacher/${TeacherId}`,
      formData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteTeacher = async (TeacherId) => {
  try {
    const response = await api.delete(`teacher/deleteteacher/${TeacherId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
